<!--P008、P009-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'MerchantManage'})">商户维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">商户详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">商户编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">商户名称</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.address" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_440" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{SUPPLIER_STATUS[search.isStop]}}</div>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue cs_margin_top_sm cs_fr"
              type="button">保存
      </button>
    </div>

    <!--门店接入-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">门店接入</div>
    </div>
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">删除
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="320px">门店编号</th>
            <th width="480px">门店名称</th>
            <th width="100%">门店启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="320px">{{item.shopNum}}</td>
            <td width="480px">{{item.shopName}}</td>
            <td width="100%">{{SUPPLIER_STATUS[item.stop]}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="320px"></td>
              <td width="480px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加门店弹窗，默认隐藏-->
    <div v-if="isDialogShopShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:372px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">接入门店</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">门店</div>
          <web-select :options="dialogShop.shopList"
                      @option-key="updateShop"
                      v-model="dialogShop.shopName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogShop.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  import {Page, PAGE_SIZE,SUPPLIER_STATUS} from "../../assets/utils/constants"
  export default {
    name: "MerchantDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          contactName: "",
          mobileNo: "",
          address: "",
          isStop: "",
        },
        orderList: [],
        selectedId: "",
        isDialogShopShow: false,
        dialogShop: {
          shopId: 0,
          shopName: "",
          shopList: [],
          hintDialog: "",
        },
        PAGE_SIZE: PAGE_SIZE,
        SUPPLIER_STATUS: SUPPLIER_STATUS
      }
    },
    created: function () {
      this.showDetail();
      this.showShop();
      this.showShopList();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.merchant.acquire.bind(this)(this.$route.query.num,(data) => {
          this.search.num = data.data.merchantNum;
          this.search.name = data.data.merchantName;
          this.search.contactName = data.data.contactName;
          this.search.mobileNo = data.data.mobileNo;
          this.search.address = data.data.merchantAddress;
          this.search.isStop = data.data.isStop;
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.num, "商户编号");
          WhParameter.verifyNotEmpty(this.search.name, "商户名称");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        this.$ajax.merchant.modify.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
        }, (data) => {
        }, true)
      },

      showShop(){
        this.selectedId = "";
        this.$ajax.merchant.listShop.bind(this)(this.$route.query.num,(data) => {
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
        }else {
          this.selectedId = "";
        }
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.merchant.deleteShop.bind(this)(this.$route.query.num,this.selectedId, (data) => {
          this.$toast("删除成功");
          this.showShop();
        }, (data) => {
        }, true)
      },
      btnAdd(){
        this.isDialogShopShow = true;
      },
      btnConfirmDialog(){
        if (this.isEmptySelect(this.dialogShop.shopId)) {
          this.dialogShop.hintDialog = "请选择门店";
          return
        }
        this.$ajax.merchant.addShop.bind(this)(this.$route.query.num,this.dialogShop.shopId, (data) => {
          this.$toast("添加成功");
          this.showShop();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog(){
        this.isDialogShopShow = false;
        this.dialogShop = {
          shopId: 0,
          shopName: "",
          shopList: [],
          hintDialog: "",
        };
      },
      showShopList(){
        this.$ajax.common.listShop.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].shopName,
            })
          }
          this.dialogShop.shopList = array;
        }, (data) => {
        }, true)
      },
      updateShop(key) {
        this.dialogShop.shopId = key;
      },
      showErrorMsg: function (msg) {
        this.dialogShop.hintDialog = msg;
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_440{width: 440px;}
  .width_246{width: 246px;}
  .margin_left_18{margin-left: 18px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/merchant/MerchantDetail.vue